/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} L6_Feat1_TitleInputs */

const es_l6_feat1_title = /** @type {(inputs: L6_Feat1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15% + IVA, sin escalados`)
};

const gl_l6_feat1_title = /** @type {(inputs: L6_Feat1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15% + IVE, sen escalados`)
};

const en_l6_feat1_title = /** @type {(inputs: L6_Feat1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15% + VAT, no tiers`)
};

/**
* | output |
* | --- |
* | "15% + VAT, no tiers" |
*
* @param {L6_Feat1_TitleInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const l6_feat1_title = /** @type {((inputs?: L6_Feat1_TitleInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<L6_Feat1_TitleInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_l6_feat1_title(inputs)
	if (locale === "en") return en_l6_feat1_title(inputs)
	return es_l6_feat1_title(inputs)
});